"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const util_ts_1 = require("@clipboard-health/util-ts");
const material_1 = require("@mui/material");
function Banner(props) {
    const { children, severity, onClose } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: severity, icon: false, sx: {
            borderRadius: 0,
            width: "100%",
            "& .MuiAlert-message": { width: "100%", textAlign: "center" },
        }, variant: "filled", ...((0, util_ts_1.isDefined)(onClose) && { onClose }), children: children }));
}
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map